/** Created by azhou on 2019/3/20.*/
<template>
    <div>
      <public-title>用户列表</public-title>
      <div class="bg-white load-area">
        <div class="d-center-between flex-wrap">
          <!-- <left-text-select class="w-45 mb-3" leftText="身份类型" :options="$GVAR.StoreTypeSea" v-model="cardType"/> -->
          <left-text-select class="w-45 mb-3" leftText="绑定微信" :options="$GVAR.bindWechatType" v-model="Wechat"/>
          <left-text-border class="w-45 mb-3" leftText="姓名" v-model="username" @enter="currentPage=1;getDataLists()"/>
          <left-text-border class="w-45 mb-3" leftText="手机号" v-model="usermobile" @enter="currentPage=1;getDataLists()"/>
          <!-- <left-text-select class="w-45 mb-3" leftText="级别" :options="$GVAR.userLevel" v-model="level"/> -->
        </div>
        <div class="d-center-between mb-3">
          <div class="text-left ml-2 text-blue">用户总数：{{AdminDataLists.total}}</div>
          <el-button type="primary" size="small" @click="currentPage=1;getDataLists()">搜索</el-button>
        </div>
        <p v-if="AdminDataLists.total<=0">当前没有数据</p>
        <div v-else>
          <ul class="list-head mt-3">
            <template  v-for="item in titleArr">
            <li class="w-20" :key="item"  v-if="item=='姓名'||item=='门店个数'">{{item}}</li>
            <li :class="item=='所属门店'?'w-80':'w-30'" :key="item + '-other'" v-else>{{item}}</li>
            </template>
          </ul>
          <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
            <li class="w-20 list-item-col">
              <p>{{item.truename}}</p>
              <el-popover placement="right" trigger="hover">
                <div >
                  <span :class="[openid(item.uid,item.wechat_openid)?'text-success':'text-danger']">{{openid(item.uid,item.wechat_openid)?'已绑定':'未绑定'}} </span>
                </div>
                <i class="iconfont icon-weixin1 male" :class="[openid(item.uid,item.wechat_openid) ? 'text-success' : 'text-muted']"  slot="reference"></i>
              </el-popover>
            </li>
            <li class="w-30 list-item-col">{{item.mobile}}</li>
             <li class="w-30 list-item-col">{{item.sex| formatVar('sex')}}</li>
            <li class="w-30 list-item-col" :class="$GFUN.userColor(item.type)">{{item.type | formatVar('StoreType')}}<span>{{item.level==1?'（集团）':''}}</span></li>
            <li class="w-30 list-item-col">{{item.level| formatVar('userLevel')}}</li>
            <li class="w-80 list-item-col">
              <!-- <p>{{item.store_list!=''&&item.store_list.length!=0?item.store_list[0].title:'无'}}</p> -->
              <p>{{title(item.store_list).title}}</p>
              <el-popover placement="right" trigger="hover">
                <div>
                   <span :class="[title(item.store_list).verify==1?'text-success':'text-danger']">{{title(item.store_list).verify==1?'已认证':'未认证'}} </span>
                </div>
                <i class=" text-link male" :class="[title(item.store_list).verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference" v-if="title(item.store_list).title!='无'"></i>
              </el-popover>
            </li>
            <li class="w-20 list-item-col">
              <el-popover placement="right" trigger="hover">
                <div v-for="(v,ind) in item.store_list" :key="ind">
                  <i class=" text-link mr-1" :class="[v.verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference"></i>
                   <!-- <span :class="[v.verify==1 ?'text-success':'text-danger']">{{v.verify==1?'已认证':'未认证'}} </span> -->
                  <!-- <i class="iconfont icon-weixin1 mr-1" :class="[v.verify==1 ? 'text-success' : 'text-muted']"></i> -->
                  <span class="mr-2">{{v.title}}</span>
                  <!-- <span class="mr-2">{{item.mobile}}</span> -->
                </div>
                <span slot="reference" class="text-link"  v-if="item.store_list">{{item.store_list?item.store_list.length+'个':'无'}}</span>
              </el-popover>
            </li>
            <!-- <li class="w-50 list-item-col" :class="item.wechat_openid!=item.uid ? 'text-success' : 'text-danger'">
              {{item.wechat_openid!=item.uid? '已绑定' : '未绑定'}}
            </li> -->
            <li class="w-30 list-item-col">{{item.num}}</li>
            <li class="w-30 list-item-col">{{item.login_time | formatTimestamp(1)}}</li>
            <li class="w-30 list-item-col-end flex-wrap">
              <span class="text-link mr-2" @click="checkDetail(item)">查看更多</span>
              <span class="text-link" @click="editUser(item)">编辑</span>
            </li>
          </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4" :page-size="20"
                         :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                         @current-change="v => this.currentPage=v"/>
        </div>
      </div>
      <el-dialog title="用户详情" :visible.sync="showDetail" center :show-close="false">
        <div class="d-flex flex-wrap">
          <div class="d-center-start w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
            <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
          </div>
          <div class="d-center-start w-50 mb-3">
            <left-text leftText="账号密码"/>
            <span v-show="showPassword" class="mr-2">{{currentItem.password}}</span>
            <i class="iconfont text-link" @click="showPassword = !showPassword"
               :class="[showPassword ? 'icon-yanjing-zheng' : 'icon-yanjing-bi']"></i>
          </div>
        </div>
        <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
      </el-dialog>
    </div>
</template>

<script>
  import { mapGetters,mapActions,mapState } from 'vuex'

  export default {
    name: 'UserLists',
    computed: {
      ...mapState(['AdminDataLists','AdminDataDetail']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getDataLists(); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        titleArr:['姓名','手机号','性别','用户类型','级别','所属门店','门店个数','登录次数','上次登录时间','操作'],
        currentPage:1,
        currentItem:{},
        showDetail:false,
        showPassword:false,
        showDetailArr:[
          {name:'用户姓名',value:'truename'},{name:'注册来源',value:'trace'},{name:'用户类型',value:'type'},
          {name:'上次登录时间',value:'login_time'},{name:'手机号',value:'mobile'},
          {name:'绑定微信',value:'wechat_openid'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'},
          {name:'职位名称',value:'position_name'},{name:'账号主体',value:'title'}
        ],
        Wechat: '',
        cardType:0,
        username: '',
        usermobile: '',
        level:'0',          //用户级别
      }
    },
    created() { this.getDataLists(); },
    methods:{
      ...mapActions(['getAdminDataLists','getItemDetail']),
      title(e){
        let tie={
          title:'无',
          verify:-1,
        }
        return Array.isArray(e)&&e.length!=0? e[0]:tie;
      },
      openid(uid,wechat_openid){
        return wechat_openid==''||uid==wechat_openid?false:true;
      },
      //获取用户列表
      getDataLists() {
        this.getAdminDataLists({
          type:'userList',
          data:{
            ...this.queryCon,
            page:this.currentPage,
            truename:this.username,
            wechat: this.Wechat,
            mobile: this.usermobile,
            num:20,
          }
        });
      },
      async checkDetail(item) {
        if (!this.$GFUN.powerIsInArray([80])) { this._alert('您没有相关权限！',null,'error'); return; }
        await this.getItemDetail({
          type:'userDetail',
          data:{
            uid:item.uid,
            // store_type:item.type
          }
        })
        this.currentItem = {
          ...this.AdminDataDetail,
          wechat_openid:` ${item.wechat_openid!=item.uid ? '已绑定' : '未绑定'}`,
          type:this.$options.filters['formatVar'](item.type,'StoreType'),
          trace:this.$options.filters['formatVar'](this.AdminDataDetail.trace,'traces'),
          login_time:item.login_time > 0 ? this.$options.filters['formatTimestamp'](item.login_time,1) : '从未登录',
          reg_time:this.$options.filters['formatTimestamp'](this.AdminDataDetail.reg_time,1)
        };
        this.showDetail = true;
      },
      editUser(item) {
        if (!this.$GFUN.powerIsInArray([81])) { this._alert('您没有相关权限！',null,'error'); return; }
        let {uid,truename,mobile,status,wechat_openid,type} = item;
        this.$router.push({name:'editUser',query:{uid,truename,mobile,status,wechat_openid,type}})
      }
    }
  }
</script>
<style scoped>
  .male{
    margin-left: 4px;
    margin-top: 4px;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
  }
</style>